import React from "react";
import { IconProps } from "../type";

function CurrencyIcon({color}:IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={color ? color :"#0DA276"}
        strokeWidth="1.2"
      ></circle> 
      <path
        fill={color ? color :"#0DA276"}
        d="M8.413 19v-4.68H7v-1.165h1.413v-1.492H7v-1.166h1.413V6h1.884l1.721 4.497h2.138V6h1.431v4.497H17v1.165h-1.413v1.493H17v1.166h-1.413V19h-1.902l-1.721-4.68H9.826V19H8.413zm1.413-5.845h1.703l-.543-1.492H9.79l.036 1.492zm4.33 3.278h.072l-.054-2.112h-.761l.743 2.112zM9.79 10.497h.76L9.79 8.24h-.073l.073 2.258zm3.188 2.659h1.214l-.036-1.494h-1.721l.543 1.493z"
      ></path>
    </svg>
  );
}

export default CurrencyIcon;